var React = require('react');

function Tiktok (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.523 4.796a5.816 5.816 0 0 1-2.29-4.589h-3.718v10.262l-.004 5.62A3.396 3.396 0 0 1 8.2 19.314a3.326 3.326 0 0 1-2.788-.31 3.405 3.405 0 0 1-1.644-2.863c-.028-1.9 1.492-3.45 3.371-3.45.371 0 .727.062 1.061.173V9.051a7.24 7.24 0 0 0-1.072-.08c-2.057 0-3.98.864-5.355 2.42a7.082 7.082 0 0 0-1.76 4.25 7.076 7.076 0 0 0 2.075 5.481 7.08 7.08 0 0 0 5.04 2.085 7.077 7.077 0 0 0 5.04-2.085 7.067 7.067 0 0 0 2.088-5.003l-.02-8.394A9.37 9.37 0 0 0 20 9.704V5.965h-.01a5.697 5.697 0 0 1-3.466-1.17z","fill":"currentColor"}));
}

Tiktok.defaultProps = {"viewBox":"0 0 20 24","fill":"none"};

module.exports = Tiktok;

Tiktok.default = Tiktok;
